import React, {useState, useEffect, useCallback} from 'react';
import CircularSlider from '@fseehawer/react-circular-slider';
import styled from 'styled-components';
//https://www.npmjs.com/package/@fseehawer/react-circular-slider

const StyledFilterCircle = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  > span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    color: #fff;
    text-transform: capitalize;
  }
  /* > div > svg {
    width: 67%;
    height: 100%;
  } */
  > div {
    > div:last-child {
      visibility: hidden;
      opacity: 0;
    }
  }
  &::before {
    display: block;
    content: "";
    position: absolute;
    width: 138px;
    height: 138px;
    box-shadow: 0 -1px 1px 1px #444;
    left: 50%;
    top: 49%;
    transform: translate(-50%,-50%);
    border-radius: 100%;
  }
`;

export default function FilterCircle (props) {

  const {setFilter, data} = props;
  const [value, setValue] = useState(0);
  const [label, setLabel] = useState("");
  const labels = ["low", "medium", "high", "very high"];
  const updateValues = useCallback((value) => {
    setValue(value);
    const currLabel = value === 0  ? "" : labels[parseInt(value/25)];
    setLabel(currLabel);
  }, [labels]);

  useEffect(() => {
    const timer = setTimeout(value === 0 ? () => setFilter(data) : () => setFilter(data, value), 1000);
    return () => clearTimeout(timer);
  }, [value]);

  return (
    <StyledFilterCircle props={props}>
      <span>{label}</span>
      <CircularSlider
        min={0}
        max={100}
        width={157}
        labelColor="transparent"
        knobColor="none"
        progressColorFrom="#00793A"
        progressColorTo="#65AC1E"
        progressSize={8}
        trackColor="#222"
        trackSize={16}
        dataIndex={!!data.value ? data.value : null}
        onChange={value => updateValues(value)}
      >
        <svg viewBox="0 0 36 36">
          <circle stroke="none" fill={value > 0 ? "#222222" : "#eeeeee"} cx="18" cy="18" r={value > 0 ? "3" : "4"} vectorEffect="non-scaling-stroke"></circle>
        </svg>
      </CircularSlider>
    </StyledFilterCircle>)
}
